import React from 'react';
import ReactDOM from 'react-dom';

import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';


class PlaylistTeaser extends React.Component{


	constructor(props){
		super(props);

		this.loop = ()=> this.update();
		this.time = 0;
	}

	componentDidMount(){
		this.loop();
	}

	update(){
		this.loop = requestAnimationFrame(()=>this.update());
		if(this.time < 500 ){
			this.time++;
			this.timer.style.width = this.time * 100 / 500 + "%";
		}else{
		 	console.log('ende');
		 	cancelAnimationFrame(this.loop);
		 	browserHistory.push(_assets.root + '/outro');
		}
	}

	render(){
		return (<div className="playlist-song-teaser">
					<div className="playlist-song-teaser-inner">
						<p>Up tomorrow:</p>
						<h2>{this.props.songs[this.props.index].title}
						<div ref={(el) => { this.timer = el; }} className="playlist-song-teaser-timer"></div>
						</h2>
						
					</div>
				</div>);
	}
}


export default PlaylistTeaser;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/playlist_teaser.js